<footer class="footer">
  <p class="text-center mt-3">
    © {{year}} Conure OLIOS | All Rights Reserved.
  </p>
</footer>
